import { render } from "./Imprimir.vue?vue&type=template&id=1f743b20&scoped=true"
import script from "./Imprimir.vue?vue&type=script&lang=js"
export * from "./Imprimir.vue?vue&type=script&lang=js"

import "./Imprimir.vue?vue&type=style&index=0&id=1f743b20&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f743b20"]])

export default __exports__